module.exports = __webpack_public_path__ + "portal/assets/img/logo.86046c60.svg";